(ns frontend.ui.component.lp-portal.report.module.free-text-card
  (:require
   [common.time :as c-time]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.card.view :as card]
   [frontend.ui.component.chart.view :as chart]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [frontend.ui.component.lp-portal.card.style :as card-style]
   [herb.core :refer [<class]]
   [frontend.ui.component.lp-portal.checkbox.view :as checkbox]
   [common.localization :as loc]
   [frontend.ui.component.text-input.view :as text-input]
   [common.util :as cu]))

(defn free-text
  [{:keys [rich-content rich-content-path
           rich-content-completed-at rich-content-completed-path]
    :as   text-data}
   {:keys [edit-mode? show-draft? save-text] :as props}]
  [text-content/free-text-with-modal
   {:html-content      rich-content
    :completed-at      rich-content-completed-at
    :completed-path    rich-content-completed-path
    :complete-changed! (when (and edit-mode?
                                  (fn? save-text))
                         (fn [new-content completed?]
                           (save-text rich-content-path
                                      new-content
                                      rich-content-completed-path
                                      (if completed?
                                        ""
                                        (str (c-time/now-millis))))))
    :show-draft?       show-draft?
    :can-edit?         edit-mode?
    :on-change         (when (and edit-mode?
                                  (fn? save-text))
                         #(save-text rich-content-path %))}])

(defn free-text-section
  [title text-data props]
  [:div
   (when-not (cu/blank-value? title)
     [:div
      {:class (<class card-style/title)}
      title])
   [free-text text-data props]])

(defn view
  [title
   {:keys [rich-content rich-content-path] :as text-data}
   {:keys [edit-mode? save-text] :as props}]
  [card/card {:title title}
   [free-text text-data props]])

(defn row-view
  [title text-data props]
  [:div
   {}
   [view title text-data props]])

(defn optional-text-card
  [{:keys [rich-content rich-content-path
           rich-content-completed-at rich-content-completed-path
           heading-path heading-text
           enabled-path enabled?]
    :as   optional-section}
   {:keys [edit-mode? show-draft? save-text] :as props}]
  (when (or edit-mode? enabled?)
    [card/card
     {:title
      (when enabled? heading-text)}
     [:<>
      (when edit-mode?
        [:div
         [:div
          {:class (<class card-style/checkbox-wrapper)}
          [:span
           {:class (<class card-style/checkbox-label)} (loc/tr :custom-heading-in-use?)]
          [:span
           {:class (<class card-style/checkbox-container)}
           [checkbox/checkbox
            {:value     enabled?
             :on-change (fn [check?]
                          (if-not enabled?
                            (do
                              (save-text heading-path (loc/tr :lp-report-custom-heading))
                              (save-text enabled-path "true"))
                            (save-text enabled-path "false")))}]]]
         (when enabled?
           [text-input/text-input
            {:type      "text"
             :value     (str heading-text)
             :on-change #(save-text heading-path (str %))}])])
      (when enabled?
        [:div
         {:class (<class card-style/spacing-top-bottom)}
         [text-content/free-text-with-modal
          {:html-content      rich-content
           :completed-at      rich-content-completed-at
           :completed-path    rich-content-completed-path
           :complete-changed! (when (and edit-mode?
                                         (fn? save-text))
                                (fn [new-content completed?]
                                  (save-text rich-content-path
                                             new-content
                                             rich-content-completed-path
                                             (if completed?
                                               ""
                                               (str (c-time/now-millis))))))
           :show-draft?       show-draft?
           :can-edit?         edit-mode?
           :on-change         (when (and edit-mode?
                                         (fn? save-text))
                                #(save-text rich-content-path %))}]])]]))
